/* Both columns follow scrolling, bounded by the product grid above reviews. */
(() => {
  if (window.mhProductScrollGallery) return;
  window.mhProductScrollGallery = true;
  const prepare = () => document.querySelectorAll('body.mh-product-page .mh-pdp-panel, body.mh-product-page .wt-product__gallery').forEach(column => {
    if (column.mhStickyObserver) return;
    const update = () => {
      if (!column.isConnected) { column.mhStickyObserver.disconnect(); window.removeEventListener('resize', update); return; }
      // Tall columns scroll naturally until their last image/content enters view.
      const top = Math.min(108, window.innerHeight - column.offsetHeight - 24);
      column.style.setProperty('--mh-pdp-sticky-top', `${top}px`);
    };
    column.mhStickyObserver = new ResizeObserver(update);
    column.mhStickyObserver.observe(column);
    window.addEventListener('resize', update, {passive:true});
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, {once:true});
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
})();
